import { ACTION_PREFIX_CHOICE } from "./actions/node/choice/abstract/choiceAbstract";
import { ACTION_PREFIX_CONDITION } from "./actions/node/condition/abstract/conditionAbstract";
import { ACTION_PREFIX_FUNCTION } from "./actions/node/function/abstract/functionAbstract";
import { ACTION_PREFIX_PARAMETER } from "./actions/node/parameter/abstract/parameterAbstract";
import { ACTION_PREFIX_UNIVERSAL } from "./actions/node/universal/abstract/universalAbstract";

const _enableLogAction = false;
const _enableLogActionParameter = true;
const _enableLogActionChoice = true;
const _enableLogActionCondition = true;
const _enableLogActionFunction = true;
const _enableLogActionUniversal = true;

export const logAction = (action, payload) => {
  if (_enableLogAction) {
    if (action.startsWith(ACTION_PREFIX_PARAMETER) && _enableLogActionParameter) {
      log(action, payload);
    }
    if (action.startsWith(ACTION_PREFIX_CHOICE) && _enableLogActionChoice) {
      log(action, payload);
    }
    if (action.startsWith(ACTION_PREFIX_CONDITION) && _enableLogActionCondition) {
      log(action, payload);
    }
    if (action.startsWith(ACTION_PREFIX_FUNCTION) && _enableLogActionFunction) {
      log(action, payload);
    }
    if (action.startsWith(ACTION_PREFIX_UNIVERSAL) && _enableLogActionUniversal) {
      log(action, payload);
    }
  }
};

const log = (action, payload) => {
  simplify(payload);
  console.log(`ACTION: ${action} `, payload);
};

const simplify = (payload) => {
  delete payload.action;
  delete payload.time;
  delete payload.status;
};
